module.exports = __webpack_public_path__ + "img/revizuire.bba678d9.svg";